module.exports = __webpack_public_path__ + "images/58e613a1acbd57fdc779a15cce11110d.svg";